module.exports = __webpack_public_path__ + "static/img/05.535d0865.jpg";